import styled from 'styled-components'

const SHADOW_CARD   = '0px 0px 4px 0px rgba(43,123,199,0.25)'
const SHADOW_SEARCH = '0px 0px 20px 0px rgba(43,123,199,0.25)'

export const PageWrapper = styled.div`
  background: white;
  min-height: 100vh;
`

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 2rem 2.5rem 1.25rem;
`

export const PageIconBox = styled.div`
  width: 4.0625rem;
  height: 4.0625rem;
  border-radius: 0.9375rem;
  background: linear-gradient(223deg, rgba(0,200,248,1) 16%, rgba(104,94,252,1) 78%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const PageIconImg = styled.img`
  width: 2.0625rem;
  height: 2.0625rem;
  object-fit: contain;
  filter: brightness(0) invert(1);
`

export const PageTitle = styled.h1`
  font-family: Poppins;
  font-size: 2rem;
  font-weight: 600;
  color: #000000;
  margin: 0;
  line-height: 1.15;
`

export const PageSubtitle = styled.p`
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 400;
  color: #000000;
  opacity: 0.55;
  margin: 0;
`

export const SearchArea = styled.div`
  padding: 0 2.5rem 1.5rem;
`

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 4.875rem;
  background: white;
  border-radius: 1.3125rem;
  box-shadow: ${SHADOW_SEARCH};
  position: relative;
`

export const SearchImg = styled.img`
  width: 2.3125rem;
  height: 2.3125rem;
  object-fit: contain;
  position: absolute;
  left: 1.4375rem;
  opacity: 0.5;
`

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-family: Poppins;
  font-size: 1.25rem;
  font-weight: 300;
  color: #000000;
  padding: 0 1rem 0 4.5rem;
  &::placeholder { color: #B1B8C5; }
`

export const SearchButton = styled.button`
  height: calc(100% - 1.5rem);
  padding: 0 2.25rem;
  background: #4465FE;
  border: none;
  border-radius: 0.8125rem;
  font-family: Poppins;
  font-size: 1.25rem;
  font-weight: 400;
  color: white;
  cursor: pointer;
  margin-right: 0.75rem;
  flex-shrink: 0;
  white-space: nowrap;
  transition: background 0.15s;
  &:hover { background: #3352e0; }
`

export const TableArea = styled.div`
  padding: 0 2.5rem 3rem;
`

export const TableCard = styled.div`
  background: white;
  border-radius: 0.75rem;
  box-shadow: ${SHADOW_CARD};
  overflow: hidden;
`

export const EmptyRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  font-family: Poppins;
  font-size: 0.9375rem;
  font-weight: 400;
  color: #BABABA;
`

/* ── Barre de filtre agence (mode admin) ──────────────────────────── */

export const FilterArea = styled.div`
  padding: 0 2.5rem 1.25rem;
`

export const FilterRow = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 0.5rem;
  background: #EFF0F6;
  border-radius: 10px;
  padding: 0.625rem 0.75rem;
`

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const FilterFieldLabel = styled.div`
  font-family: Poppins;
  font-size: 0.72rem;
  font-weight: 600;
  color: #5a6170;
`

export const FilterSearchBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  & img {
    position: absolute;
    left: 0.55rem;
    height: 0.72rem;
    opacity: 0.4;
    z-index: 1;
    pointer-events: none;
  }
  & input {
    height: 2rem;
    width: 16rem;
    border: 1px solid #D8D8D8;
    border-radius: 6px;
    background: white;
    font-family: Poppins;
    font-size: 0.8rem;
    color: #1A1A2E;
    padding: 0 0.75rem 0 1.75rem;
    outline: none;
    &::placeholder { color: #B1B8C5; }
    &:focus { border-color: #4465FE; }
  }
`

/* ── Tableau plat (mode non-admin) ───────────────────────────────── */

export const TableHeader = styled.div`
  display: flex;
  align-items: center;
  background: #F4F4F4;
  border-radius: 0.75rem 0.75rem 0 0;
  height: 3.0625rem;
  padding: 0 1rem;
`

export const HeaderCell = styled.div`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 400;
  color: #000000;
  text-transform: uppercase;
  text-align: ${props => props.$align || 'left'};
  width: ${props => props.$w || 'auto'};
  flex: ${props => props.$flex || '0 0 auto'};
`

export const TableBody = styled.div`
  display: flex;
  flex-direction: column;
`

export const TableRow = styled.div`
  display: flex;
  align-items: center;
  padding: 0.875rem 1rem;
  min-height: 3.5rem;
  border-bottom: 1px solid #F4F4F4;
  &:last-child { border-bottom: none; }
  &:hover { background: #FAFBFF; }
  transition: background 0.1s;
`

export const Cell = styled.div`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: ${props => props.$bold ? 600 : 400};
  color: #000000;
  width: ${props => props.$w || 'auto'};
  flex: ${props => props.$flex || '0 0 auto'};
  white-space: ${props => props.$wrap ? 'normal' : 'nowrap'};
  overflow: ${props => props.$wrap ? 'visible' : 'hidden'};
  text-overflow: ${props => props.$wrap ? 'unset' : 'ellipsis'};
  text-align: ${props => props.$align || 'left'};
`

/* ── Accordéon — ligne agence ─────────────────────────────────────── */

export const AgencyBlock = styled.div`
  border-bottom: 1px solid #F0F2F8;
  &:last-child { border-bottom: none; }
`

export const AgencyRow = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem 1.25rem;
  gap: 0.875rem;
  cursor: pointer;
  background: ${props => props.$open ? '#F6F7FE' : 'white'};
  transition: background 0.15s;
  &:hover { background: #F6F7FE; }
`

export const ArrowBtn = styled.div`
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  background: ${props => props.$open ? '#EEF2FF' : '#F3F4F6'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.$open ? '#4F46E5' : '#9CA3AF'};
  font-size: 0.625rem;
  transform: rotate(${props => props.$open ? '90deg' : '0deg'});
  transition: transform 0.2s ease, background 0.15s, color 0.15s;
  flex-shrink: 0;
`

export const AgencyNameText = styled.span`
  font-family: Poppins;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1A1A2E;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const AgencyStats = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
`

export const StatPill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.75rem;
  border-radius: 100px;
  font-family: Poppins;
  font-size: 0.8125rem;
  font-weight: 500;
  white-space: nowrap;
  background: ${props => props.$type === 'price' ? '#F0FDF4' : '#EEF2FF'};
  color: ${props => props.$type === 'price' ? '#16A34A' : '#4F46E5'};
  border: 1px solid ${props => props.$type === 'price' ? '#BBF7D0' : '#C7D2FE'};
`

/* ── Sous-tableau ─────────────────────────────────────────────────── */

export const SubTableWrap = styled.div`
  overflow: hidden;
  max-height: ${props => props.$open ? '9999px' : '0'};
  transition: max-height ${props => props.$open ? '0.25s ease-in' : '0.15s ease-out'};
`

export const SubTableHead = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem 1.25rem 0.5rem 2.75rem;
  background: #ECEEF8;
  border-top: 1px solid #E0E3F0;
  border-bottom: 1px solid #E0E3F0;
`

export const SubHeadCell = styled.div`
  font-family: Poppins;
  font-size: 0.6875rem;
  font-weight: 600;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  width: ${props => props.$w || 'auto'};
  flex: ${props => props.$flex || '0 0 auto'};
  text-align: ${props => props.$align || 'left'};
`

export const SubRow = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75rem 1.25rem 0.75rem 2.75rem;
  border-bottom: 1px solid #F0F2F8;
  background: #F8F9FC;
  &:last-child { border-bottom: none; }
  transition: background 0.1s;
  &:hover { background: #F0F2FA; }
`

export const SubCell = styled.div`
  font-family: Poppins;
  font-size: 0.8125rem;
  font-weight: ${props => props.$bold ? 600 : 400};
  color: ${props => props.$muted ? '#9CA3AF' : '#1A1A2E'};
  width: ${props => props.$w || 'auto'};
  flex: ${props => props.$flex || '0 0 auto'};
  text-align: ${props => props.$align || 'left'};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: ${props => props.$wrap ? 'normal' : 'nowrap'};
`

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.1875rem 0.625rem;
  border-radius: 100px;
  font-family: Poppins;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  background: ${({ status }) => status === 'completed' ? '#E1F5DD' : status === 'pending' ? '#FFF5A8' : '#FFE4E4'};
  color: ${({ status }) => status === 'completed' ? '#34B81A' : status === 'pending' ? '#F6AB33' : '#E53E3E'};
`

export const ActionBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  height: 1.625rem;
  padding: 0 0.75rem;
  background: #8EA2FF;
  border: 1px solid #4465FE;
  border-radius: 4px;
  font-family: Poppins;
  font-size: 0.8125rem;
  font-weight: 400;
  color: white;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.15s;
  & img {
    width: 0.875rem;
    height: 0.875rem;
    object-fit: contain;
    filter: brightness(0) invert(1);
    flex-shrink: 0;
  }
  &:hover { opacity: 0.85; }
`

export const FilterActionBtn = styled.button`
  height: 2rem;
  padding: 0 1rem;
  background: #4465FE;
  border: none;
  border-radius: 6px;
  font-family: Poppins;
  font-size: 0.8rem;
  font-weight: 500;
  color: white;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  transition: background 0.15s;
  & img { width: 0.875rem; height: 0.875rem; object-fit: contain; filter: brightness(0) invert(1); }
  &:hover:not(:disabled) { background: #3352e0; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`

export const FilterResetBtn = styled.button`
  height: 2rem;
  padding: 0 0.75rem;
  background: white;
  border: 1px solid #D8D8D8;
  border-radius: 6px;
  font-family: Poppins;
  font-size: 0.8rem;
  color: #6B7280;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  &:hover { border-color: #9CA3AF; }
`
